import { useEffect, useState } from 'react'

const useBlobUrl = (blob: Blob | undefined) => {
  const [url, setUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    const objectUrl = blob !== undefined ? URL.createObjectURL(blob) : undefined
    setUrl(objectUrl)
    return () => {
      if (objectUrl !== undefined) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [blob])

  return url
}

export default useBlobUrl
